export const DEFAULT_DIVIDER_PICTURE_SUBTITLE =
  "Join our first digital conference.";
export const DEFAULT_DIVIDER_PICTURE_DESCRIPTION =
  "Over five days of thought-provoking interviews, inspirational talks, interactive workshops, and a lot more. You’ll be looking at the world through the eyes of some of the brightest minds around, and you’ll get a glimpse of what our future might look like. Ready to ride?";
export const DEFAULT_DIVIDER_PICTURE_CTA_TEXT = "Register";
